import React, { useEffect } from "react";
import "./App.css";
import "./index.css";
import "./components/Common-Component/Common_Css/Form_Css/Form_Css.css";
import "./components/Common-Component/Common_Css/Policy_Css/Policy_Css.css";
import "./components/Common-Component/Common_Css/Form_Css/Form_Css.css";

import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import AboutUs from "./components/AboutUs/AboutUs";
import Visiting_Cards from "./components/Visiting_Cards/Visiting_Cards";
import ContactUs from "./components/ContactUs/ContactUs";
import FAQ from "./components/FAQ/FAQ";
import "./components/Common-Component/Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn.css";
import Career from "./components/Career/Career";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import ReturnPolicy from "./components/ReturnPolicy/ReturnPolicy";
import TermsConditions from "./components/TermsConditions/TermsConditions";
import ProductDetailsPage from "./components/ProductDetailsPage/ProductDetailsPage";
import Career_outer from "./components/Career/Career_outer/Career_outer";
import Blog from "./components/Blog/Blog";
import JobApplicationForm from "./components/JobApplicationForm/JobApplicationForm";
import EntryPage from "./components/entry_page/EntryPage";
import LoginPage from "./components/Login_Page/LoginPage";
import ResetPass from "./components/Reset_Pass_Flow/Reset_Pass/ResetPass";
import ShareOtp from "./components/Reset_Pass_Flow/Share_Otp/ShareOtp";
import SetNewPass from "./components/Reset_Pass_Flow/Set_New_Pass/SetNewPass";
import SignUp from "./components/SignUp_Page/SignUp";
import WishList from "./components/WishList/WishList";
import AddressBook from "./components/AddressBook/AddressBook";
import Cart from "./components/Cart/Cart";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Blog_inner from "./components/Blog/Blog_inner/Blog_inner";
import MyOrder from "./components/MyOrder/MyOrder";
import AccountSetting from "./components/AccountSetting/AccountSetting";
import Job_details from "./components/Job_details/Job_details";
import Re_Order from "./components/Re_Order/Re_Order";
import JobLocationDetails from "./components/JobLocationDetails/JobLocationDetails";
import Cart_Process from "./components/Order_Process/Process_cart";

import Order_Process from "./components/Order_Process/Order_Process";
import Help_lottie_holder from "./components/Help_lottie_holder/Help_lottie_holder";
import ReferAndEarn from "./components/ReferAndEarn/ReferAndEarn";
// import JobInfoComponent from "./components/JobApplicationForm/JobApplicationForm";

function App() {
  const location = useLocation();
  const hideHeaderFooter = [
    "/",
    "/login",
    "/reset-pass",
    // "/share-otp",
    "/set-new-pass",
    "/sign-up",
  ].includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {!hideHeaderFooter && <Header />}
      <Routes>
        {/* login flow start */}
        <Route path="/" element={<EntryPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-pass" element={<ResetPass />} />
        {/* <Route path="/share-otp" element={<ShareOtp />} /> */}
        <Route path="/set-new-pass" element={<SetNewPass />} />
        <Route path="/sign-up" element={<SignUp />} />
        {/* login flow end */}
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/visiting-cards" element={<Visiting_Cards />} />
        {/* <Route path="/careers" element={<Career_outer />} /> */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-inner/:id" element={<Blog_inner />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/careers" element={<Career />} />
        <Route
          path="/job-application-form/:id"
          element={<JobApplicationForm />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route
          path="/product-details-page/:id"
          element={<ProductDetailsPage />}
        />
        <Route path="/wishlist" element={<WishList />} />
        <Route path="/address-book" element={<AddressBook />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/my-order" element={<MyOrder />} />
        <Route path="/job-details/:id" element={<Job_details />} />
        <Route path="/re-order/:id" element={<Re_Order />} />
        <Route path="/cart-process" element={<Cart_Process />} />
        <Route path="/order-process" element={<Order_Process />} />
        <Route path="/account-setting" element={<AccountSetting />} />
        <Route
          path="/job-location-details/:id"
          element={<JobLocationDetails />}
        />
        <Route path="/refer-and-earn" element={<ReferAndEarn />} />
        {/* <Route path="/job-info/:id" element={<JobInfoComponent />} /> */}
      </Routes>
      {!hideHeaderFooter && <Footer />}

      <Help_lottie_holder />
    </>
  );
}

export default App;
